var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStarFillHalf = function SvgIcStarFillHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M11.938 4.075a.72.72 0 0 0-.63-.435L8.101 3.5 6.652.417A.72.72 0 0 0 6 0a.72.72 0 0 0-.653.418l-1.45 3.081-3.204.14a.72.72 0 0 0-.631.437.74.74 0 0 0 .13.79L2.57 7.43l-.899 3.65a.74.74 0 0 0 .246.758.72.72 0 0 0 .798.074L6 10.058l3.312 1.867q.156.075.319.076a.735.735 0 0 0 .7-.913l-.9-3.66 2.394-2.58a.74.74 0 0 0 .114-.773",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "evenodd",
    d: "M6 10.058V0c.282 0 .532.16.652.418l1.45 3.081 3.205.14a.735.735 0 0 1 .516 1.209L9.43 7.429l.9 3.66a.735.735 0 0 1-.658.912h-.082a.7.7 0 0 1-.278-.075z",
    clipRule: "evenodd"
  })));
};
export default SvgIcStarFillHalf;